import '@afinius/plugins/ant-design';
import '@afinius/theme/global.scss';
import '@afinius/theme/presets/green.scss';

import { beforeErrorHooks } from '@afinius/api-client/client';
import { i18n } from '@afinius/i18n/index';
import { query, queryOptions } from '@afinius/plugins/query';
import { registerSentry } from '@afinius/plugins/sentry';
import { registerStaleChunkReload } from '@afinius/plugins/stale-chunk-reload';
import { trackEvent } from '@afinius/utilities/analytics';
import { createPinia } from 'pinia';
import { createApp } from 'vue';

import App from './App.vue';
import { router } from './router';

beforeErrorHooks.push(trackEvent);
registerStaleChunkReload(router);

const app = createApp(App);
const pinia = createPinia();

registerSentry(app, router, { hasSessionRecovery: true });

app.use(pinia);
app.use(router);
app.use(i18n);
app.use(query, queryOptions);

app.mount('#app');
